import { z } from "zod";

/**
 * Schema for validating the request data for app check token creation.
 * Only requires the appId - authentication token will be obtained from Authorization header.
 */
export const GetAppCheckTokenSchema = z.object({
  /**
   * The Firebase App ID for which to create a token
   */
  appId: z.string().min(1),
});

export type GetAppCheckTokenPostBody = z.infer<typeof GetAppCheckTokenSchema>;

/**
 * Type for App Check token response
 */
export interface GetAppCheckTokenResponse {
  token: string;
  expiresAt: number;
}
